import classes from "./ScanDetails.module.css";
import {useContext} from "react";
import QRCodeViewItemContext from "../QRCodeViewItemContext";

/**
 * Scan details.
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function ScanDetails() {
    /**
     * QRCodeViewItemContext
     * @since 0.1.9
     * @author Kacper Faber
     */
    const ctx = useContext(QRCodeViewItemContext);

    return (
        <div className={classes.root}>
            <div className={classes.counter}>
                { ctx.qrCode?.counter }
            </div>

            <div className={classes.label}>
                Skanów
            </div>
        </div>
    );
}

// noinspection JSUnusedGlobalSymbols
export default ScanDetails;

// TODO: ScanDetails.tsx
//  Implemented, but not clickable